export const projectData = [
  {
    id: "1",
    duration: "Dec 2020 – July 2022",
    client: "Phrama Coviglance Clients",
    desc: "Worked Build Tenant Config create module , Build Tenant Config edit module , Build Tenant Config view module , Build Tenant list module , Build dashboard module , Build static widget module , Build message count module , Build message status module , Build configurable pie chart using d3.js, bug fixes for UI Improvement.",
    project: "PV Clinical",
  },
  {
    id: "2",
    duration: " Feb 2020 – Dec 2020",
    client: "Countable",
    desc: "Adinovis is an application used by chartered accountants to make their process easy and online ,it is used to mange account and give financial statement yearly basis, do online chat with client and consultancy through chat",
    project: "Adinovis",
  },
  {
    id: "3",
    duration: "March 2019 – Feb 2020",
    client: "Edmond School",
    desc: "DCP Direct copier program ,this is program built for many device situated at different location are handle at one place ,which mean multiple devices in single device ,a user can do photo copy at difrent location and r charge as per number of page copied and color used in it.",
    project: "DCP",
  },
];
